import { render } from "./extension.vue?vue&type=template&id=5bfb6dd9&scoped=true"
import script from "./extension.vue?vue&type=script&lang=js"
export * from "./extension.vue?vue&type=script&lang=js"

import "./extension.vue?vue&type=style&index=0&id=5bfb6dd9&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bfb6dd9"]])

export default __exports__